export default '/reading/@slug'
